import { FC, PropsWithChildren } from 'react';

const Truncate: FC<PropsWithChildren<{ className?: string }>> = ({ children, className }) => (
  <div className={`grid w-full overflow-hidden ${className}`}>
    <div className="truncate">{children}</div>
  </div>
);

export default Truncate;
